import React, { useState, useEffect } from 'react';
import { parseMetadata } from '../utils/metadataParser';

const PopupContent = ({ pin, onExplore }) => {
  const [content, setContent] = useState({
    title: '',
    firstParagraph: '',
    firstImage: null,
    category: '',
    date: '',
    loading: true,
    error: false
  });

  useEffect(() => {
    const fetchAndParseMarkdown = async () => {
      try {
        const response = await fetch(`/content/${pin.markdownFile}`);
        if (!response.ok) {
          throw new Error('Failed to load content');
        }
        const markdownText = await response.text();
        
        // Parse metadata and get content without metadata section
        const { metadata, contentWithoutMetadata } = parseMetadata(markdownText);
        
        // Parse the content (without metadata) to extract title, first paragraph, and first image
        const lines = contentWithoutMetadata.split('\n');
        let title = '';
        let firstParagraph = '';
        let firstImage = null;
        
        // Extract title (first H1 after metadata)
        for (let line of lines) {
          if (line.startsWith('# ')) {
            title = line.substring(2).trim();
            break;
          }
        }
        
        // Extract first image (fixed regex to handle title attributes)
        const imageRegex = /!\[.*?\]\(([^"\s]+)(?:\s+"[^"]*")?\)/;
        const imageMatch = contentWithoutMetadata.match(imageRegex);
        if (imageMatch) {
          firstImage = imageMatch[1];
        }
        
        // Extract first paragraph (first non-empty line that's not a header or image)
        for (let line of lines) {
          const trimmedLine = line.trim();
          if (trimmedLine && 
              !trimmedLine.startsWith('#') && 
              !trimmedLine.startsWith('!') &&
              !trimmedLine.startsWith('![') &&
              trimmedLine.length > 20) { // Ensure it's a substantial paragraph
            firstParagraph = trimmedLine;
            break;
          }
        }
        
        setContent({
          title: metadata.title || title || pin.title,
          firstParagraph: metadata.description || firstParagraph || pin.description,
          firstImage,
          category: metadata.category || pin.category,
          date: metadata.date || '',
          loading: false,
          error: false
        });
      } catch (error) {
        setContent({
          title: pin.title,
          firstParagraph: pin.description,
          firstImage: null,
          category: pin.category,
          date: '',
          loading: false,
          error: true
        });
      }
    };

    fetchAndParseMarkdown();
  }, [pin]);

  if (content.loading) {
    return <div className="popup-loading">Loading...</div>;
  }

  return (
    <div className="popup-content" onClick={() => onExplore(pin.id)}>
      {/* Image thumbnail */}
      {content.firstImage && (
        <div className="popup-image">
          <img src={content.firstImage} alt={content.title} />
        </div>
      )}
      
      {/* Content */}
      <div className="popup-text">
        <h3 className="popup-title">{content.title}</h3>
        {content.date && <div className="popup-date">{content.date}</div>}
        <div className="popup-category">{content.category}</div>
        <p className="popup-description">
          {content.firstParagraph.length > 120 
            ? (() => {
                const truncated = content.firstParagraph.substring(0, 120);
                const lastSpaceIndex = truncated.lastIndexOf(' ');
                const cleanText = lastSpaceIndex > 0 ? truncated.substring(0, lastSpaceIndex) : truncated;
                return (
                  <>
                    {cleanText}... <button 
                      className="read-more-link" 
                      onClick={(e) => {
                        e.stopPropagation();
                        onExplore(pin.id);
                      }}
                    >
                      read more
                    </button>
                  </>
                );
              })()
            : content.firstParagraph
          }
        </p>
      </div>
    </div>
  );
};

export default PopupContent;